import React from "react";

const EmptyConversationState = () => {
  return (
    <div className="flex-col-centered items-center justify-center py-16 px-4">
      <div className="flex-col-centered items-center gap-3 text-center">
        <div className="w-16 h-16 bg-grey-100 rounded-full flex-row-centered items-center justify-center">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-grey-400"
          >
            <path
              d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="flex-col-centered items-center gap-1">
          <h3 className="text-base font-[600] text-grey-700 mb-1">No conversation yet</h3>
          <p className="text-sm font-[400] text-grey-500 max-w-sm leading-relaxed">
            Start engaging with your lead to begin building a meaningful conversation. Messages will
            appear here once the communication begins.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyConversationState;
